import hpiRos from '../../../assets/files/hpi-ros.json';
import hpiStart from '../../../assets/files/hpi-start.json';
export function fetchSxListForHPI() {
    return [...fetchHpiSxByJson(hpiRos), ...fetchHpiSxByJson(hpiStart)];
}
export function fetchHpiSxByJson(rows) {
    const hpiSxs = rows
        // .map((row) => {
        //   return row;
        // })
        .filter((row) => {
        return row['sx-key'] && row['question-key'];
    });
    return hpiSxs;
}
